import React from "react";
import resumeData from "../data/resumeData";

const Bio = ({ className }) => (
  <div className={className}>{resumeData.summary}</div>
);

export default Bio;
